
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Button from './Button';
import { newsArticles } from '../data/newsData';

const NewsPreview = () => {
  const latestNews = newsArticles.slice(0, 3);

  return (
    <section className="py-16 bg-slate-800/95">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="section-title text-white drop-shadow-lg mb-4">Latest News</h2>
          <p className="text-xl text-slate-200 drop-shadow-md max-w-3xl mx-auto">
            Stay updated with our recent activities and community initiatives
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {latestNews.map((article) => (
            <article key={article.id} className="bg-slate-900/90 rounded-lg overflow-hidden shadow-lg border border-slate-700 hover:border-amber-500/50 transition-all duration-300">
              <div className="aspect-video bg-slate-800 overflow-hidden">
                <img 
                  src={article.image} 
                  alt={article.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-amber-500/20 text-amber-400 px-3 py-1 rounded-full text-sm font-medium">
                    {article.category}
                  </span>
                  <span className="text-slate-400 text-sm">{article.date}</span>
                </div>
                <h3 className="text-xl font-bold mb-3 text-white leading-tight">
                  {article.title}
                </h3>
                <p className="text-slate-300 mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <Link to={`/news/${article.id}`}>
                  <Button variant="text" className="text-amber-400 hover:text-amber-300 p-0 font-medium">
                    Read More <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </Link>
              </div>
            </article>
          ))}
        </div>
        
        <div className="text-center">
          <Link to="/news">
            <Button variant="primary" size="lg" className="bg-amber-500 hover:bg-amber-600 text-white">
              View All News
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NewsPreview;
